import { Roles } from 'src/shared/enums';
import { RoleGuard } from '../shared/auth/guards/role.guard';
import { AuthGuard } from '../shared/auth/guards/auth.guard';

export const fieldTeamsPaths = {
	default: '',
	root: 'field-teams',
	list: 'list',
	detail: ':id',
};

export const fieldTeamsFragments = {
	default: [fieldTeamsPaths.default],
	root: [fieldTeamsPaths.default, fieldTeamsPaths.root],
	list: [fieldTeamsPaths.default, fieldTeamsPaths.root, fieldTeamsPaths.list],
	detail: (id: number) => [fieldTeamsPaths.default, fieldTeamsPaths.root, id],
};

export const fieldTeamsDefaultAuthRoles = [
	Roles.Admin,
	Roles.FieldDirector,
	Roles.FieldManager,
	Roles.FieldSupport,
	Roles.HR,
];

export const fieldTeamsDefaultAuth = {
	canActivate: [AuthGuard, RoleGuard],
	data: { roles: fieldTeamsDefaultAuthRoles },
};
